import { createContext } from 'react';
import { FieldValues, UseFormReturn } from 'react-hook-form';
import _ from 'lodash';
import * as QuestionnaireApiModels from '@/typings/questionnaires-api-models';

export type QuestionnaireFormContextType = {
  formContextId: string;
  formMethods: UseFormReturn<FieldValues>;
  getExplanationHtml: (fieldKey: string) => string | null;
  setExplanationHtml: (fieldKey: string, explanationHtml: string | null) => void;
  getResponseSource: (fieldKey: string) => QuestionnaireApiModels.QuestionnaireResponse['source'];
  setResponseSource: (fieldKey: string, source: QuestionnaireApiModels.QuestionnaireResponse['source']) => void;
  getBulkResponseSources: (args?: { rowFieldKey: string }) => Record<string, QuestionnaireApiModels.QuestionnaireResponse['source']>
  mergeResponseSources: (source: Record<string, QuestionnaireApiModels.QuestionnaireResponse['source']>) => void;
  getAiRequestId: (fieldKey: string) => string | null;
  setAiRequestId: (fieldKey: string, aiRequestId: string) => void;
  getAutofillStatus: (fieldKey: string) => boolean;
  setAutofillStatus: (fieldKey: string, status: boolean) => void;
  getBulkAutofillStatuses: (args?: { rowFieldKey: string }) => Record<string, boolean>;
  mergeAutofillStatuses: (statuses: Record<string, boolean>) => void;
  getBulkAiRequestIds: (args?: { rowFieldKey: string }) => Record<string, string | null>;
  mergeAiRequestIds: (source: Record<string, string | null>) => void;
  setValue: (arg1: {
    key: string;
    value: unknown;
    source?: QuestionnaireApiModels.QuestionnaireResponse['source'];
    aiRequestId?: string;
    explanationHtml?: string | null;
    hasAutofillRun?: boolean;
  }) => void;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const unimplementedFunction: any = (): void => {
  throw new Error('Function not implemented.');
};

const QuestionnaireFormContext = createContext<QuestionnaireFormContextType>({
  formContextId: 'default',
  formMethods: {} as any, // eslint-disable-line @typescript-eslint/no-explicit-any
  getAiRequestId: unimplementedFunction,
  getAutofillStatus: unimplementedFunction,
  getBulkAiRequestIds: unimplementedFunction,
  getBulkAutofillStatuses: unimplementedFunction,
  getBulkResponseSources: unimplementedFunction,
  getExplanationHtml: unimplementedFunction,
  getResponseSource: unimplementedFunction,
  mergeAiRequestIds: unimplementedFunction,
  mergeAutofillStatuses: unimplementedFunction,
  mergeResponseSources: unimplementedFunction,
  setAiRequestId: unimplementedFunction,
  setAutofillStatus: unimplementedFunction,
  setExplanationHtml: unimplementedFunction,
  setResponseSource: unimplementedFunction,
  setValue: unimplementedFunction,
});

export default QuestionnaireFormContext;
